import { registerGame, startGame, getGameInstance } from "./RGS/Start";
import { Loader } from "./RGS/utils/load";
import { Caller } from ".";
import { loadingTutorial } from ".";
import { Formatter } from ".";
import { MongibelloForgeUtilities } from "./RGS/mongibelloForgeUtilities";
import { LanguageManager } from "./RGS/utils/LanguageManager";

declare global {
  interface Window {
    gsm?: any;
    MongibelloForge?: any;
  }
}

const api = {
  registerGame,
  startGame,
  getGameInstance,
  Loader,
  Caller,
  loadingTutorial,
  Formatter,
  MongibelloForgeUtilities,
  LanguageManager
};

// così soddisfi sia il boot vecchio (gsm) che il nuovo nome (MongibelloForge)
(window as any).gsm = api;
(window as any).MongibelloForge = api;

//console.log("window.MongibelloForge inizializzati");